import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';

export const SuperAdminRoute = ({ children }) => {
  const { user, loading, isSuperAdmin} = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading-spinner">در حال بارگذاری...</div>;
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!isSuperAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
};
